<script setup lang="ts">
import { setCookie } from 'core/services/cookie'

const openModal = ref(true)
const isClosedAllowed = ref(false)

function closeModal() {
  setCookie('redirect_modal_closed')
  openModal.value = false
}
</script>

<template>
  <BaseModal v-model="openModal" :is-closed-allowed="isClosedAllowed">
    <template #content>
      <div class="modal flex flex-col items-center text-center sm:p-8">
        <img src="@/assets/waving-hand.png" class="max-w-20 max-h-20 lg:max-w-full lg:max-h-full relative">

        <div class="flex justify-between">
          <h2 class="text-center sm:w-2/3 mx-auto md:leading-15">
            Vitajte na stránkách Porovnajto.sk!
          </h2>
        </div>

        <b class="text-text-default font-normal">
          Spojili sme sily, aby sme Vám mohli ponúknuť ešte širšiu ponuku služieb. Aktuálne tak nájdete všetko, na čo ste
          boli zvyknutí u Rychlepoistenie.sk na stránkach Porovnajto.sk – a dokonca ešte oveľa viac!
        </b>

        <div class="logo-block">
          <img src="@/assets/porovnajto_logo.svg?url" class="max-w-full max-h-full" alt="logo porovnajto">
          <AppIcon :icon="['far', 'plus']" class="text-brand" />
          <img src="@/assets/rp-logo.png" class="max-w-full max-h-full" alt="logo rychle poistenie">
        </div>

        <p class="mb-3 sm:mb-6">
          Náš tím sa nezmenil, sme tu stále pre Vás a ešte silnejší než kedykoľvek predtým!
          <br>
          <br>
          Ak máte akékoľvek otázky, kontaktujte nás na
          <a href="tel:0800 400 300">0800 400 300</a> alebo  <a href="mailto:info@porovnajto.sk">info@porovnajto.sk</a>
          a my Vám ich radi zodpovieme.
        </p>

        <BaseButton render="primary" class="max-w-xs" @click="closeModal">
          Pokračovať na Porovnajto.sk
        </BaseButton>
      </div>
    </template>
  </BaseModal>
</template>

<style lang="scss" scoped>
.modal {
  background: url("@/assets/confetti.png") no-repeat;
  margin: -20px;
  margin-bottom: 0;
  max-width: 295px;
  padding: 10px;
  @screen sm {
    max-width: 620px;
    padding: 20px;
  }
  @screen md {
    max-width: 780px;
    margin-bottom: 0;
  }
}

.logo-block {
  @apply flex flex-col sm:flex-row gap-2 sm:gap-4 justify-center items-center my-4 sm:my-10;
  & img {
    width: 170px;
    height: auto;
    @screen sm {
      width: 200px;
    }
  }
}
</style>
